import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { BonusSection } from './components/BonusSection';
import { ChangeSection } from './components/ChangeSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
const PIXEL_ID = '1750632936154197';
export function App() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', PIXEL_ID);
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3udkn7x6lywax">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="3ubzu8bzxzlf6" />
      </noscript>

      <div className="w-full bg-white" data-id="element-2" data-mp="86cld4uwd7jn">
        <PurchasePopup data-id="element-3" data-mp="3gl4pnbwh7qhe" />
        <main data-id="element-4" data-mp="3gmfulf1nr4a3">
          <Hero data-id="element-5" data-mp="3glwcnyc0cfw2" />
          <PainSection data-id="element-6" data-mp="3gja6a20us6ff" />
          <SystemSection data-id="element-7" data-mp="3bmbg1ukb8jmi" />
          <BonusSection data-id="element-8" data-mp="3bn2zk70muqwf" />
          <ChangeSection data-id="element-9" data-mp="3bnuv5hu8comp" />
          <PricingCard data-id="element-10" data-mp="3bk736n4foaa3" />
          <Guarantee data-id="element-11" data-mp="3qaxtfqqdn1b3" />
          <Testimonials data-id="element-12" data-mp="3qbg07hao0xx9" />
          <FAQ data-id="element-13" data-mp="3qcqzb3t61hi1" />
          <FinalCTA data-id="element-14" data-mp="3qdakqui0yo0t" />
        </main>
        <Footer data-id="element-15" data-mp="3ljxvqj9fof7j" />
      </div>
    </>;
}